module.exports = "/_next/static/images/7ddef53605e0905952d0611f1f428658-value-proposal-xs-2x.png";